module.exports = " <div class=vc-picker-slot :class=\"{'vc-picker-slot-divider': divider}\" :style=\"{'width': width}\"> <div v-if=!divider class=vc-picker-slot-wrapper :class=\"{'animate': animate}\" :style=\"{'height': contentHeight + 'px'}\" v-el:wrapper> <div class=vc-picker-item :style=\"{'text-align': textAlign}\" :class=\"{'selected': item === value}\" v-for=\"item in values\">{{item.text || item}}</div> </div> <div v-if=divider>{{ content }}</div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/picker/picker-slot.vue
 ** module id = 472
 ** module chunks = 1
 **/